import { BackButton, ContainerForm, Hint } from '@/components';
import { Component, Vue } from 'vue-property-decorator';
import { CreateElement, VNode, VNodeData } from 'vue';
import { formMixins } from '@/components/SignUpForm/mixins';
import { mapActions, mapGetters } from 'vuex';
import {
  Rules,
  VuetifyInput,
  IRecoveryPassFormComponent,
  IRecoveryPassForm } from '@/types';
import { VTextField } from 'vuetify/lib';

type Rule = string | boolean;

@Component({
  name: 'RecoveryPassForm',
  computed: {
    ...mapGetters('accounts', ['translations']),
    t(): IRecoveryPassFormComponent { return (this as any).translations.passRecover as IRecoveryPassFormComponent; },
  },
  methods: {
    ...mapActions(['showCentralAlert']),
    ...mapActions('accounts', ['resetPassword']),
  },
})
export default class RecoveryPassForm extends Vue implements IRecoveryPassForm {

  public email;
  public errorBucket = new Map<string, string[]>();
  public hasErrors = false;
  public resetPassword;
  public formRules: Rules = formMixins.rules;
  public show: boolean = true;
  public t!: IRecoveryPassFormComponent;
  public rulesEmail: Rule[] = [];

  public validate() {
    this.errorBucket = new Map();
    const input = this.$refs.email as VuetifyInput;
    if (!input.validate(true)) {
      this.errorBucket.set('email', input.errorBucket);
    }
    return !this.errorBucket.size;
  }

  private prepareErrors(value: string) {
    this.rulesEmail = [
      this.formRules.required(value, this.$store.getters.translations.field_errors.required),
      this.formRules.email(value,
        {
          at: this.t.errorsMessages.emailWrong ?? '',
          user: this.t.errorsMessages.emailWrong ?? '',
          domain: this.t.errorsMessages.emailWrong ?? '',
        },
      ),
    ];
  }

  private render(createElement: CreateElement): VNode {

    const back: VNode | boolean = this.show && createElement(BackButton, {
      domProps: {
        name: 'back-button',
      },
      attrs: {
        id: 'back-button-form',
      },
      slot: 'over',
      props: {
        name: this.t.backButtonName,
      },
      class: [this.$vuetify.breakpoint.xsOnly && 'mobile'],
    });

    const description = createElement('div', {
      class: [
        {
          'flex-center': true,
          'recovery-pass': true,
        },
        this.$vuetify.breakpoint.xsOnly
          ? 'pass-form__mobile'
          : 'pass-form',
      ],
    }, [createElement('p',
        {
          class: [this.$vuetify.breakpoint.xsOnly && 'description-mobile'],
        },
      this.t.description)]);

    const email: VNode = createElement(VTextField, {
      attrs: {
        name: 'email',
      },
      props: {
        autofocus: true,
        error: this.errorBucket.has('email'),
        errorMessages: this.errorBucket.get('email'),
        'browser-autocomplete': 'email',
        height: 28,
        label: this.t.email,
        rules: this.rulesEmail,
      },
      on: {
        input: (value: string) => {
          this.email = value.trim();
          this.prepareErrors(this.email);
        },
        focus: (e) => this.errorBucket = new Map(),
        blur: (e) => this.prepareErrors(e.target.value),
      },
      class: {
        'input-wrapper': true,
      },
      ref: 'email',
    });

    const actionButton: VNode = createElement('button', {
      class: [
        this.$vuetify.breakpoint.xsOnly
          ? 'orange-big-button__mobile'
          : 'orange-big-button',
      ],
      attrs: {
        type: 'submit',
      },
      on: {
        click: async (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (!this.validate()) { return; }
          this.resetPassword(this.email).then((response) => {
            if (response && response.status === 204) {
              this.$router.push({name: 'messageSendMail', params: {email: this.email}});
            }
            if ((response.status === 400 || response.status > 401) && response.status < 500) {
              this.errorBucket = new Map();
              const { mobile_errors } = response.data;
              mobile_errors.forEach((error) => {
                this.errorBucket.set(error.field, error.messages);
              });
            }
          }).catch((error) => console.error(error));
        },
      },
    }, this.t.buttonName);

    const hint: VNode  = createElement(Hint, {
      props: {
        text: this.t.hint,
        linkTo: 'accounts',
      },
      style: {
        'align-self': 'center',
        'margin-top': '19px',
      },
      slot: 'bottom',
    });

    const data: VNodeData = {
      props: {
        passClass: 'recovery-pass',
      },
      style: {
        display: 'flex',
        'justify-content': 'flex-start',
      },
      class: 'recovery-pass',
      on: {
        'show-hide': (value) => this.show = value,
      },
    };

    return createElement(ContainerForm, data, [
      back,
      this.$slots.title,
      description,
      email,
      actionButton,
      hint,
    ]);
  }
}
